import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  theme: localStorage.getItem("theme") || "purple",
  darkTheme: JSON.parse(localStorage.getItem("darkTheme")!) || {
    color: 'rgb(39, 40, 53)',
    backgroundColor: 'rgb(255, 255, 255)',
    isDarkTheme: false
  }
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    reducerTheme: (state: Draft<any>, action: PayloadAction<any>) => {
      state.theme = action.payload;
    },
    reducerDarkTheme: (state: Draft<any>, action: PayloadAction<any>) => {
      state.darkTheme = action.payload;
    },
  },
});

export const { reducerTheme, reducerDarkTheme } = themeSlice.actions;

export default themeSlice.reducer;
